// Client reviews — edit this file by hand to add/remove reviews.
// Fields per review:
//   name    (required)  client first name, e.g. 'Martijn'
//   country (required)  client country, e.g. 'Netherlands' — always displayed
//   text    (required)  the quote
//   trek    (optional)  which trek they did, e.g. 'Manaslu Circuit' — must match the
//                       trek's `name` in treks.js to appear on that trek's page
//   rating  (optional)  1–5 stars
//   date    (optional)  e.g. 'Oct 2024'
//   photo   (optional)  filename in public/reviews/, e.g. 'martijn.jpg'
//                       If omitted, the card shows the client's initials instead.
//                       (Get the client's permission before publishing a real photo.)
//   title   (optional)  short bold headline for the review, e.g. 'Unforgettable adventure'
//   photos  (optional)  array of trip photo filenames in public/reviews/ shown in the
//                       gallery strip and on the review card
//   helpful (optional)  starting count for the "Helpful" button
//   source  (optional)  'Google' or 'TripAdvisor' — shows a "✓ Verified on …" label
// Only `name`, `country`, and `text` are needed — the rest render only if present.

export const reviews = [
  {
    id: 1,
    name: 'Placeholder One',
    country: 'Netherlands',
    trek: 'Manaslu Circuit',
    rating: 5,
    date: 'Oct 2024',
    photo: 'sample-1.svg',
    title: 'Placeholder headline — unforgettable adventure',
    photos: ['sample-1.svg', 'sample-2.svg'],
    helpful: 2,
    source: 'Google',   // demo — shows the "✓ Verified on Google" label; set real source or remove
    text: 'PLACEHOLDER — replace with a real client quote. This one is tagged Manaslu so it shows on the Manaslu page. Make this one longer to demonstrate the "See more" toggle: describe the teahouses, the pass crossing at dawn, how the guide handled the altitude days, what the food was like, and why the traveller would recommend booking directly. Keep going for a few sentences so the collapsed state visibly truncates and the expand control appears under the review text.',
  },
  {
    id: 2,
    name: 'Placeholder Two',
    country: 'France',
    trek: 'Manaslu Circuit',
    rating: 5,
    date: 'Apr 2024',
    photo: 'sample-2.svg',
    title: 'Placeholder headline — no words to explain',
    photos: ['sample-2.svg'],
    helpful: 0,
    text: 'PLACEHOLDER — replace with a real client quote. Also tagged Manaslu so the Manaslu page shows two reviews.',
  },
  {
    id: 3,
    name: 'Placeholder Three',
    country: 'Germany',
    trek: 'Everest Base Camp',
    rating: 5,
    date: 'Nov 2024',
    title: 'Placeholder headline — the roof of the world',
    text: 'PLACEHOLDER — replace with a real client quote. This one appears in the home page testimonials strip.',
  },
  {
    id: 4,
    name: 'Placeholder Four',
    country: 'Belgium',
    trek: 'Annapurna Circuit',
    rating: 4,
    date: 'Oct 2024',
    title: 'Placeholder headline — classic route, well guided',
    text: 'PLACEHOLDER — replace with a real client quote. This one also appears on the home page. Rated 4 stars so the rating filters have something to distinguish.',
  },
]
